export default __webpack_public_path__ + "static/media/Website_TC.ef9fedff.pdf";